import {
  EducatorDashboardApplication,
  EducatorDashboardDataRow
} from './educator-dashboard-data.model';
import { DashboardAdmin } from '@app/shared/directives/queue-status-filter.constant';
import {
  buildQueueStatusRowFromEducatorApplication,
  resolveQueueApplicationStatusDisplay
} from '@app/shared/utils/queue-application-status-display.util';

/** Fingerprint / background label from first `p_complaince` row (matches Application History grid). */
export function getFingerprintStatusFromCompliance(
  row: EducatorDashboardDataRow | null | undefined
): string {
  const compliance = row?.p_complaince;
  if (Array.isArray(compliance) && compliance.length > 0) {
    const first = compliance[0] as Record<string, unknown>;
    return String(first?.cd_fingerprint_status ?? first?.fingerprint_status ?? '').trim();
  }
  return '';
}

/** When BG is required and a fingerprint label exists, show `base + label` (same as Application History). */
export function combinedApplicationStatus(
  app: Pick<EducatorDashboardApplication, 'app_status' | 'bg_required'> | null | undefined,
  fingerprintLabel: string
): string {
  const appStatus = app?.app_status ?? '';
  const isBg = app?.bg_required === true;
  const bg = String(fingerprintLabel ?? '').trim();
  return isBg && bg ? `${appStatus} + ${bg}` : appStatus;
}

/**
 * Same display labels as educator my-app (`dashboardadmin` + {@link DashboardAdmin}).
 * Used for lookup header and Application History grid.
 */
export function resolveLookupApplicationStatusDisplay(
  app: EducatorDashboardApplication | null | undefined,
  educatorDashboardRow: EducatorDashboardDataRow | null | undefined
): string {
  const fp = getFingerprintStatusFromCompliance(educatorDashboardRow);
  if (!app) {
    return combinedApplicationStatus(app, fp);
  }
  const queueRow = buildQueueStatusRowFromEducatorApplication(
    app as unknown as Record<string, unknown>,
    fp
  );
  return (
    resolveQueueApplicationStatusDisplay(queueRow, DashboardAdmin, 'dashboardadmin') ??
    combinedApplicationStatus(app, fp)
  );
}
